import { render, staticRenderFns } from "./menu-upload-grid.vue?vue&type=template&id=7454f77d"
import script from "./menu-upload-grid.vue?vue&type=script&lang=js"
export * from "./menu-upload-grid.vue?vue&type=script&lang=js"
import style0 from "./menu-upload-grid.vue?vue&type=style&index=0&id=7454f77d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuUploadGridFilters: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-upload-grid-filters.vue').default,MenuUploadBulkUploadScreen: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-upload-bulk-upload-screen.vue').default,MenuUploadEmptyFilteredItemsTile: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-upload-empty-filtered-items-tile.vue').default,MenuUploadGridItem: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-upload-grid-item.vue').default})
